import { SummaryModel } from "src/app/modules/common/entity/summary.model";
import { PermissionsModel } from "src/app/modules/common/entity/permissions.model";
import {DeviceDefinitionSummaryModel} from "../../../definition/api/entity/deviceDefinitionSummary.model";

export class MedicalDeviceSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    label: string;
    serialNumber: string;
    active: boolean;
    definition: DeviceDefinitionSummaryModel;
}

